<template>
  <Modal
    v-model="isShow"
    :width="750"
    :loading="loading"
    :mask-closable="false"
    @on-ok="ok"
  >
    <h3 slot="header" class="modal-header">新增服务工单</h3>
    <Form
      style="margin-top:24px"
      ref="searchData"
      :model="searchData"
      :rules="ruleValidate"
      :label-width="120">
      <Row>
        <Col span="10">
          <FormItem prop="projectFid" label="项目名称">
            <Select v-model="searchData.projectFid" placeholder="请选择" @on-change="getProjectName">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in projectList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12" class="max64">
          <FormItem prop="houseId" label="房间号" style="position: relative">

<!--            :label-in-value="true"-->


            <Select
              v-model="searchData.houseId"
              placeholder="请选择"
              filterable
              remote
              :remote-method="remoteMethod"
              :loading="remoteLoading"
              multiple
              @on-change="getRoomCode"

            >
              <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
            <span class="count" v-if="searchData.houseId.length">{{searchData.houseId.length}}</span>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem prop="" label="合同号">
            <Input v-model="contractCodeShow.text" disabled type="text" placeholder="合同号"></Input>
            <span class="count" v-if="contractCodeShow.value.length">{{contractCodeShow.value.length}}</span>

          </FormItem>
        </Col>
        <Col span="12">
          <FormItem prop="orderStatus" label="工单状态">
            <Select v-model="searchData.orderStatus" placeholder="请选择">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in orderStatusList" :key="'s2'+index" :value="item.value">{{item.text}}
              </Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem prop="orderTypeCode" label="一级分类">
            <Select v-model="searchData.orderTypeCode" placeholder="请选择" @on-change="getTwo">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in oneStep" :key="'s1'+index" :value="item.typeCode">{{item.typeName}}
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem prop="orderTypeCode2" label="二级分类">
            <Select v-model="searchData.orderTypeCode2" placeholder="请选择" @on-change="getScore">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in twoStep" :key="'s1'+index" :value="item.typeCode">{{item.typeName}}
              </Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem prop="orderScore" label="预计得分">
            <Input v-model="searchData.orderScore" disabled type="text" placeholder="预计得分"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem prop="exceptDealTime" label="预计办结时间">
            <Date-picker style="display: block" type="date" v-model="searchData.exceptDealTime" placeholder="请选择"></Date-picker>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="22">
          <FormItem label="描述">
            <Input v-model="searchData.remark" type="textarea"></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>

<script>
  import {formatDateTime} from "../../../../../../utils/format";
  import {findWorkOrderTypeList, fuzzyRoom, roomOwn, addWorkOrder} from 'api/workOrder'

  export default {
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectList: {
        type: Array,
        default() {
          return []
        }
      },
      orderStatusList: {
        type: Array,
        default() {
          return []
        }
      },
      oneStep: {
        type: Array,
        default() {
          return []
        }
      },
    },
    computed: {
      contractCodeShow(){
        let ret=[]
        let list=this.cacheList.concat(this.roomList)
        let cacheId=[]

        list.forEach(ele=>{
          if(this.searchData.houseId.indexOf(ele.value)!==-1 && ele.contractCode && cacheId.indexOf(ele.value)===-1){
            ret.push(ele.contractCode)
            cacheId.push(ele.value)
          }
        })

        return {
          text:ret.join('、'),
          value:ret
        }

      },
      saveParams() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }

        let houseInfo=[]
        let cacheId=[]


        let list=this.cacheList.concat(this.roomList)
        // let map={}
        // list.forEach(ele=>{
        //   map[ele.value]={
        //     contractCode:(map[ele.value]&&map[ele.value].contractCode)?map[ele.value].contractCode:ele.contractCode,
        //     "houseNumber":ele.text
        //   }
        // })
        list.forEach(ele=>{
          if(this.searchData.houseId.indexOf(ele.value)!==-1  && cacheId.indexOf(ele.value)===-1){

            houseInfo.push({
              // "contractCode":map[ele.value].contractCode,
              "contractCode":ele.contractCode||'',
              "houseNumber":ele.text
            })
            cacheId.push(ele.value)
          }
        })

        return {
          projectName: this.searchData.projectName,
          projectFid: this.searchData.projectFid,
          // houseNumber: this.searchData.houseNumber,
          // contractCode: this.searchData.contractCode,
          orderStatus: this.searchData.orderStatus,
          orderTypeCode: this.searchData.orderTypeCode2,
          orderScore: this.searchData.orderScore,
          remark: this.searchData.remark,
          exceptDealTime: f(this.searchData.exceptDealTime),
          houseInfo:houseInfo
        }
      }
    },
    data() {
      const validates = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请选择预计办结时间'));
        } else {
          callback();
        }
      };
      return {
        cacheList:[],
        searchData: {
          projectFid: '',
          houseNumber: '',
          houseId: [],
          contractCode: '',
          orderStatus: 0,
          orderTypeCode: '',
          orderTypeCode2: '',
          orderScore: null,
          exceptDealTime: null,
          remark: '',
        },
        roomList: [],
        remoteLoading: false,
        isShow: false,
        loading: true,
        twoStep: [],
        ruleValidate: {
          projectFid: [{required: true, message: '请选择项目名称', trigger: 'change', type: 'string'}],
          // houseId:[{ required: true, message: '请选择房间号', trigger: 'change',type:'string'}],
          orderStatus: [{required: true, message: '请选择工单状态', trigger: 'change', type: 'number'}],
          orderTypeCode: [{required: true, message: '请选择一级分类', trigger: 'change', type: 'string'}],
          orderTypeCode2: [{required: true, message: '请选择二级分类', trigger: 'change', type: 'string'}],
          exceptDealTime: [
            {required: true, message: '请选择预计办结时间', trigger: 'change', type: 'array', validator: validates}
          ],
        }
      }
    },
    watch: {
      n() {
        this.searchData = {
          projectFid: '',
          houseNumber: '',
          houseId: [],
          contractCode: '',
          orderStatus: 0,
          orderTypeCode: '',
          orderTypeCode2: '',
          orderScore: null,
          exceptDealTime: null,
          remark: '',
        }
        this.$refs['searchData'].resetFields();
        this.searchData.remark = ''
        this.cacheList=[]
        this.isShow = true
      }
    },
    methods: {
      getProjectName(value) {
        this.searchData.houseId = []
        this.roomList = []
        // this.searchData.contractCode = ''
        this.projectList.forEach(ele => {
          if (ele.value === value) {
            this.searchData.projectName = ele.text
          }
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      remoteMethod(query) {
        this.cacheList=this.cacheList.concat(this.roomList)
        if (query && this.searchData.projectFid) {
          this.remoteLoading = true;
          let params = {
            projectid: this.searchData.projectFid,
            roomnumber: query
          }
          fuzzyRoom(params).then(res => {
            if (!res.data) {
              this.remoteLoading = false;
              this.roomList = [];
            }
            res.data.forEach(ele => {
              ele['label'] = ele.text
              ele['contractCode']=''
              ele['disabled']=false
              ele['noCode']=false
            })
            this.remoteLoading = false;
            this.roomList = res.data;
          }).catch(err => {
            // this.searchData.contractCode = ''
          })
        } else {
          this.roomList = [];
          this.searchData.houseId = []
          // this.searchData.contractCode = ''
        }
      },
      getRoomCode(room){
        this.roomList.forEach(ele=>{
          if(this.searchData.houseId.indexOf(ele.value)!==-1 && !ele.contractCode && !ele.noCode){
            roomOwn({roomId:ele.value})
              .then(res => {
                if(res.data){
                  ele.contractCode = res.data[0].contractNumber;

                }
              }).catch(err=>{
              ele['noCode']=true
              //   let index=this.searchData.houseId.indexOf(ele.value)
              // this.searchData.houseId.splice(index)
              // ele['disabled']=true
            })
          }
        })

        // if(room.value){
        //   this.searchData.houseNumber = room.label
        //   this.searchData.houseId = room.value
        //   roomOwn({roomId:this.searchData.houseId})
        //   .then(res => {
        //     this.searchData.contractCode = res.data[0].contractNumber;
        //   }).catch(err=>{
        //     this.searchData.contractCode = ''
        //   })
        // } else {
        //   this.searchData.contractCode = ''
        //   this.searchData.houseId = []
        // }
      },
      getTwo(value) {
        if (!value) {
          this.twoStep = []
          return
        }
        findWorkOrderTypeList({
          type: 1,
          parentFid: value,
        })
          .then(res => {
            this.twoStep = res.data;
          })
      },
      getScore(value) {
        this.twoStep.forEach((ele, index) => {
          if (ele.typeCode === value) {
            this.$nextTick(() => {
              this.searchData.orderScore = ele.score
            })
          }
        })
      },
      ok() {
        this.$refs['searchData'].validate(bool => {
          if (bool) {
            let params = {
              ...this.saveParams
            }
            addWorkOrder(params)
              .then(res => {
                if (res.code === 0) {
                  this.$Message.success('保存成功')
                  this.$emit('done')
                }
              })
              .catch(error => {
                this.$Message.error('保存失败')
              })
              .finally(() => {
                this.isShow = false
              })

          } else {
            this.changeLoading();
          }
        })
      }
    }
  }
</script>

<style scoped>
  .count {
    display: inline-block;
    min-width: 16px;
    min-height: 16px;
    position: absolute;
    top: -10px;
    right: -10px;
    background: #cfa868;
    color: #ffffff;
    border-radius: 100%;
    line-height: 15px;
    text-align: center;
    font-weight: 600;
  }

</style>
